import { useState } from "react";
import { useSelector } from "react-redux";

import { Typography, Box, Divider, Grid, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { ShaDowBox } from "../../../../components/boxes";
import { pluralize } from "../../../../services";
import { SegmentTab } from "../../components/SegmentTab";
import { ClassTab } from "../../components/ClassTab";
import { LocationTab } from "../../components/LocationTab";
import { SelectFilterComponent } from "../../components/SelectFilterComponent";
import { Steps } from "../../../demo/components/StepBar";

const useStyles = makeStyles(() => ({
  divider: {
    height: 15,
    width: 2,
    marginTop: 5,
  },
  chartBox: {
    height: 270,
    borderRadius: 8,
    marginTop: 20,
  },
  title: {
    padding: "10px 0 0 20px",
  },
}));

const byFilters = ["SEGMENT", "CLASS", "LOCATION"];

export const AnalysisTab = ({ setStep, setIsDataConfirmed, resetSteps }) => {
  const classes = useStyles();
  const { user, clusters } = useSelector((state) => state.auth);
  const preliminaryStage = clusters[0].preliminary_stage;
  const [byFilter, setByFilter] = useState(
    preliminaryStage?.owner === "TENANTS_CONSUMPTION"
      ? byFilters[0]
      : preliminaryStage?.owner === "OWN_CONSUMPTION" &&
        ["HOTELS", "HEALTH_CARE_CENTERS"].includes(preliminaryStage?.type) &&
        preliminaryStage?.flexible_category
      ? byFilters[1]
      : byFilters[2]
  );
  const [count, setCount] = useState(0);

  return (
    <Box>
      <Grid container alignItems="baseline" style={{ marginTop: 56, marginBottom: 32 }}>
        {(preliminaryStage?.owner === "OWN_CONSUMPTION" && preliminaryStage?.flexible_category) ||
        preliminaryStage?.owner === "TENANTS_CONSUMPTION" ? (
          <>
            <Box sx={{ mr: 1 }}>
              <Typography variant="h2">Analysis</Typography>
            </Box>
            <Grid container style={{ width: "auto" }}>
              <Box sx={{ mr: 1 }}>
                <Typography variant="h4">by:</Typography>
              </Box>
              {preliminaryStage?.owner === "TENANTS_CONSUMPTION" ? (
                <SelectFilterComponent
                  title="Segment"
                  byFilter={byFilter}
                  onClick={() => setByFilter(byFilters[0])}
                />
              ) : (
                <SelectFilterComponent
                  title="Class"
                  byFilter={byFilter}
                  onClick={() => setByFilter(byFilters[1])}
                />
              )}
              <Box sx={{ mx: 1 }}>
                <Divider orientation="vertical" className={classes.divider} />
              </Box>
              <SelectFilterComponent
                title="Location"
                byFilter={byFilter}
                onClick={() => setByFilter(byFilters[2])}
              />
            </Grid>
          </>
        ) : (
          <Typography variant="h4">
            {pluralize(count, "Solar Installation", { plural: "Solar Installations" })} analysis by Locations
          </Typography>
        )}
        <Typography
          variant="h4"
          onClick={() => {
            setIsDataConfirmed(false);
            setStep(Steps.updateData);
            localStorage.setItem(
              `step-${user.cluster_registration_flow}-uid${user.id}`,
              Steps.updateData
            );
          }}
          style={{ color: COLORS.purple, marginLeft: "auto", cursor: "pointer" }}
        >
          Re-upload data
        </Typography>
      </Grid>

      <ShaDowBox style={{ padding: 16 }}>
        <Grid></Grid>
        {byFilter === byFilters[0] ? (
          <SegmentTab resetSteps={resetSteps} />
        ) : byFilter === byFilters[1] ? (
          <ClassTab resetSteps={resetSteps} />
        ) : (
          <LocationTab setCount={setCount} resetSteps={resetSteps} />
        )}
      </ShaDowBox>
    </Box>
  );
};
